module.exports = __webpack_public_path__ + "img/qn-logo.d5cfadea.png";